module.exports = __webpack_public_path__ + "img/straight_curve_line_icon.08c346ea.svg";